import React from "react";
import {CookiesProvider} from "react-cookie";
import {initGoogleTagManager} from "./src/hooks/init-google-tag-maanager";

import "./assets/css/global.css";

export const wrapRootElement = ({element}) => <CookiesProvider>{element}</CookiesProvider>;
export const onClientEntry = () => {
	initGoogleTagManager();
};
